import { IGameCharacter } from '../../../../../../../api/types/character'
import React from 'react'
import { Avatar, Chip, Theme } from '@mui/material'
import { BACKEND_URL } from '../../../../../../../config'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(0.2),
    },
  })
)

interface UserCharBadgeProps {
  game_char: IGameCharacter
  isSelected: boolean
  handleDelete: () => void
  handleClick: () => void
}

export const UserCharBadge: React.FC<UserCharBadgeProps> = ({
  game_char,
  handleDelete,
  handleClick,
  isSelected,
}) => {
  const classes = useStyles()
  return (
    <>
      <Chip
        className={classes.root}
        avatar={<Avatar alt="avatar" src={BACKEND_URL + game_char.user.avatar} />}
        label={game_char.character.name}
        variant={isSelected ? 'filled' : 'outlined'}
        onDelete={handleDelete}
        onClick={handleClick}
      />
    </>
  )
}
